import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useApi from '../../hooks/useApi';
import { Country } from 'country-state-city';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const { data: users, isLoading } = useApi('/users/userRole/specialist');

  const handleSearch = () => {
    navigate('/specialists', {
      state: { searchQuery, countryFilter },
    });
  };

  return (
    <section
      className="relative bg-cover bg-center h-screen md:h-[80vh] lg:h-[70vh] overflow-hidden"
      style={{ backgroundImage: "url('./assets/images/header.png')" }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-[#3D1F10]/90 via-[#3D1F10]/60 to-transparent"></div>
      <div className="container mx-auto px-6 py-16 relative z-10 flex items-center h-full">
        <div className="flex flex-col md:flex-row items-center justify-between w-full gap-8">
          <div className="w-full md:w-1/2 space-y-8">
            <div className="text-left animate-fade-in">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 text-primary">
                Discover Your Farming Expert
              </h1>
              <p className="text-lg md:text-xl lg:text-2xl max-w-lg leading-relaxed text-white">
                Connect with leading agricultural professionals to optimize your farming practices and maximize yield.
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-center gap-4 bg-white/95 p-6 rounded-xl shadow-xl transform transition-all hover:shadow-2xl duration-300">
              <div className="relative w-full md:w-1/2">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">🔍</span>
                <input
                  type="text"
                  placeholder="Search experts or specialties"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary/50 bg-gray-50 text-gray-800 placeholder-gray-400 transition duration-200"
                />
              </div>
              <div className="relative w-full md:w-1/2">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">🌐</span>
                <select
                  value={countryFilter}
                  onChange={(e) => setCountryFilter(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary/50 bg-gray-50 text-gray-800 appearance-none transition duration-200"
                  disabled={isLoading}
                >
                  <option value="" className="text-gray-800">Select Country</option>
                  {Country.getAllCountries().map((country) => (
                    <option key={country.isoCode} value={country.isoCode} className="text-gray-800">
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <button
                onClick={handleSearch}
                className="w-full md:w-auto bg-primary text-white px-6 py-2 rounded-lg hover:bg-secondary transition-all duration-300 font-semibold"
              >
                Find Experts
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;